import { Box, Chip, Link, Typography } from '@mui/material';
import React from 'react';
export function renderFileNameColumn(t, row, navigate, searchParams) {
    const activeTabId = searchParams.get('tab');
    return (React.createElement(Box, { sx: { display: 'flex', pr: 3, width: '100%' } },
        row.columns.directory ? (React.createElement(Link, { variant: 'body1', underline: 'none', color: 'info', sx: { cursor: 'pointer', color: 'inherit', overflow: 'hidden', textOverflow: 'ellipsis', width: 'auto' }, onClick: (e) => {
                e.preventDefault();
                e.stopPropagation();
                const urlParams = new URLSearchParams();
                if (activeTabId) {
                    urlParams.set('tab', activeTabId);
                }
                navigate({
                    pathname: row.id,
                    search: urlParams.toString(),
                });
            } }, row.columns.name)) : (React.createElement(Typography, { sx: { wordBreak: 'break-word' } }, row.columns.name)),
        row.columns.checkOutUserId && React.createElement(Chip, { label: t('common.checkedOut'), color: 'warning', size: 'small', sx: { marginLeft: 1 } })));
}
